import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5487ef7e")

_pushScopeId("data-v-5487ef7e")
const _hoisted_1 = { class: "left-meeting" }
const _hoisted_2 = { class: "meeting-info" }
const _hoisted_3 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Typography = _resolveComponent("Typography")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Typography, {
          fontType: "header",
          fontSize: "600"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.t('left.title')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
})